// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1M2y7","title":"Images45_title__2_NJd","images":"Images45_images__2gZJ_"};